export const pathMapper = (path: string) => {
  if (path === "/") {
    return "main";
  }
  if (path.includes("marketing-landing")) {
    return "marketing landing";
  }
  if (path.includes("get-predata")) {
    return "webform";
  }
  if (path.includes("analyze")) {
    return "analyze";
  }
  if (path.includes("step=7")) {
    return "calculate";
  }
  if (path.includes("step=8")) {
    return "service";
  }
  if (path.includes("step=9")) {
    return "service detail";
  }
};
